import { render, staticRenderFns } from "./grindingdropdown.vue?vue&type=template&id=14c8ba54&"
import script from "../../ts/articleattributes/grindingdropdown.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/grindingdropdown.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports